export default "__VITE_ASSET__Blf1uTED__"